import { Drawer, DrawerOverlay, DrawerContent, Box } from "@chakra-ui/react";
import React, { useEffect, useState } from "react";
import { useRoot } from "../../../context/RootContext";
import CustomButton from "../../atoms/CustomButton/CustomButton";
import styles from "./edit-profile.module.css";
import ProfileImg from "../../../assets/profile/edit_profile.svg";
import ProfileIcon from "../../../assets/svgs/profileIcon.svg";
import FloatingLabelInput from "./FloatingLabelInput";
import FloatingLabelDropdown from "./FloatingLabelDropdown";
import EditButton from "../../../assets/svgs/editButton.svg";
import BackIcon from "../../../assets/profile/backIcon.svg";
import {
  getCurriculum,
  getGrades,
  updateProfile } from
"../../../network/LearnApiService";
import {
  isEmptyOrNull,
  isNotEmptyOrNull,
  urlString } from
"../../../utils/common-utils";
import { setCookie, USER_UPDATE_MESSAGE } from "../../../utils/TutorConstants";
import { useNavigate } from "@remix-run/react";
import { StorageService } from "../../../utils/StorageUtils";
import RESOURCES from "../../../resourses/RESOURCES";

const ProfileBottomSheet = () => {
  const { openEditProfile, setOpenEditProfile } = useRoot();
  const [userDetails, setUserDetails] = useState({});
  const [grades, setGrades] = useState([]);
  const [message, setMessage] = useState({});
  const [isSaveDisabled, setIsSaveDisabled] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    if (openEditProfile) {
      setMessage({});
      let details = StorageService.getItem("user_additional_details");
      details = typeof details === "object" ? details : JSON.parse(details);
      if (details) {
        //console.log("Details", details);
        setUserDetails({
          firstName: details?.firstName,
          lastName: details?.lastName,
          school: details?.school,
          grade: details?.grade,
          grade_name: details?.grade_name,
          userId: details?._id,
          phoneNumber: details?.phoneNumber,
          emailID: details?.email,
          isOnBoardingSkipped: details?.isOnBoardingSkipped,
          onBoardingDetails: details?.onBoardingDetails
        });
      }
      fetchGrades();
    }
  }, [openEditProfile]);

  useEffect(() => {
    const { firstName, lastName, grade } = userDetails;
    const isDisabled =
    isEmptyOrNull(firstName) ||
    isEmptyOrNull(lastName) ||
    isEmptyOrNull(grade);
    setIsSaveDisabled(isDisabled);
  }, [userDetails]);

  const fetchCurriculumId = async () => {
    const { success, data } = await getCurriculum();
    if (success && data?.statusCode === 200) {
      return data?.data?.[0]?.id || "";
    }
    return "";
  };

  const fetchGrades = async () => {
    const curriculumId = await fetchCurriculumId();
    const { success, data } = await getGrades(curriculumId);
    if (success && data?.statusCode === 200) {
      const initialData = data?.data?.map((item) => ({
        value: item.id,
        label: item.name
      }));
      setGrades(initialData);
    }
  };

  const handleCancel = () => {
    // navigate(-1);
    setOpenEditProfile(false);
  };

  const handleChange = (key, value) => {
    setUserDetails((prevDetails) => ({ ...prevDetails, [key]: value }));
  };

  const input = (label, key, isDisabled = false) =>
  <FloatingLabelInput
    label={label}
    value={userDetails[key] || ""}
    setValue={(val) => handleChange(key, val)}
    isDisabled={true} />;



  const dropdown = (label, key, options) =>
  <FloatingLabelDropdown
    label={label}
    value={userDetails[key] || ""}
    setValue={(val) => handleChange(key, val)}
    options={options}
    isDisabled={true} />;


  const handleSave = async () => {
    let { success } = await updateProfile(userDetails);
    if (success) {
      handleUpdateExistingDetails(userDetails);
    } else {
      setMessage({
        success: "",
        error: USER_UPDATE_MESSAGE?.error
      });
    }
  };

  const handleUpdateExistingDetails = (details) => {
    StorageService.setItem("name", details?.firstName);
    StorageService.setItem("gradeId", details?.grade);
    let gradeName = grades.find((item) => item.value == details.grade);
    gradeName = gradeName?.label || "";
    details.grade_name = gradeName;
    let existingDetails = StorageService.getItem("user_additional_details");
    existingDetails =
    typeof existingDetails === "object" ?
    existingDetails :
    JSON.parse(existingDetails);
    existingDetails = existingDetails ? existingDetails : {};
    const updatedDetails = { ...existingDetails, ...details };
    StorageService.setItem(
      "user_additional_details",
      JSON.stringify(updatedDetails)
    );
    setMessage({
      success: USER_UPDATE_MESSAGE?.success,
      error: ""
    });
    setTimeout(() => {
      setOpenEditProfile(false);
      window.location.reload();
    }, 1000);
  };

  const getUserProfileImage = () => {
    let profile = isNotEmptyOrNull(userDetails?.onBoardingDetails?.Avatar) ?
    userDetails?.onBoardingDetails?.Avatar?.includes("boy") ?
    RESOURCES.images.three_boy?.[
    parseInt(
      userDetails?.onBoardingDetails?.Avatar?.replace("boy_", ""),
      10
    )] :

    RESOURCES.images.three_girl?.[
    parseInt(
      userDetails?.onBoardingDetails?.Avatar?.replace("girl_", ""),
      10
    )] :

    ProfileIcon;
    return profile;
  };

  const handleEditProfile = () => {
    setCookie("isEdit", true);
    navigate(`${urlString}/onboarding`, {
      replace: true
    });
  };

  if (!openEditProfile) return null;

  return (
    <Drawer
      placement="bottom"
      onClose={() => handleCancel()}
      isOpen={openEditProfile}
      size={"full"}>

      <DrawerOverlay />
      <DrawerContent className={styles.container} sx={{ bgColor: "#f5f4fa" }}>
        <div className={styles["back-icon"]}>
          <img src={BackIcon} onClick={handleCancel} />
          Edit Profile
        </div>
        <div className={styles["center-container"]}>
          <div className={styles["profile-img-container"]}>
            <img
              className={styles["profile-img"]}
              src={getUserProfileImage()}
              alt="Profile" />

            <img
              className={styles["edit-icon-img"]}
              src={EditButton}
              alt="Edit Icon"
              onClick={handleEditProfile} />

          </div>
          <div className={styles["edit-profile-text"]}>Edit Profile</div>
          <div className={styles["edit-profile-desc"]}>
            It will take a couple of minutes. Change profile settings.
          </div>
          <div className={styles["input-container"]}>
            {input("First Name", "firstName")}
            {input("Last Name", "lastName")}
          </div>
          <div className={styles["input-container"]}>
            {input("Email ID", "emailID", true)}
            {input("School", "school", true)}
          </div>
          <div className={styles["input-container2"]}>
            {dropdown("Grades", "grade", grades)}
            {input("", "")}
          </div>
          {message?.success &&
          <div className={styles["success"]}>{message?.success}</div>
          }
          {message?.error &&
          <div className={styles["error"]}>{message?.error}</div>
          }
          <div className={styles["buttons-container"]}>
            <CustomButton
              label="Close"
              extraStyle="cancel-btn"
              handleClick={handleCancel} />

            {/* <CustomButton
               label="Save Changes"
               extraStyle="save-btn"
               isDisabled={isSaveDisabled}
               handleClick={() => {
                 !isSaveDisabled && handleSave();
               }}
              /> */}
          </div>
        </div>
      </DrawerContent>
    </Drawer>);

};

export const EditProfile = () => {
  return (
    <React.Fragment>
      <ProfileBottomSheet />
    </React.Fragment>);

};